import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, MapPin, Mail } from "lucide-react";
import { SERVICES } from "../data/services";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#070707]">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src="/logo.jpg" alt="Logo Resineko" className="h-16 w-16 rounded-full object-cover ring-1 ring-[#d4af6a]/40" />
            <div>
              <p className="font-serif text-3xl font-medium tracking-[0.15em] text-[#F4F4F0]">RESINEKO</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-[#d4af6a]">L'art de sublimer vos espaces</p>
            </div>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#8C8C8C]">
            Revêtements de sols en résine • Béton ciré • Moquette de pierre • Peinture bâtiment
          </p>
          <p className="mt-6 inline-flex items-center gap-2 border border-[#047857]/50 px-4 py-2 text-[11px] uppercase tracking-[0.25em] text-[#2FBF8F]">
            Intervention partout en France
          </p>
          <div className="mt-6 space-y-2.5 text-sm text-[#F4F4F0]/75">
            <a href="tel:+33783693101" data-testid="footer-phone" className="flex items-center gap-2.5 transition-colors hover:text-[#2FBF8F]">
              <Phone size={14} className="shrink-0 text-[#2FBF8F]" /> 07 83 69 31 01
            </a>
            <p className="flex items-center gap-2.5">
              <MapPin size={14} className="shrink-0 text-[#2FBF8F]" /> Daux (31700) — Région toulousaine
            </p>
            <a href="mailto:resineko31@gmail.com" data-testid="footer-email" className="flex items-center gap-2.5 transition-colors hover:text-[#2FBF8F]">
              <Mail size={14} className="shrink-0 text-[#2FBF8F]" /> resineko31@gmail.com
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#8C8C8C]">Nos solutions</p>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/${s.slug}`} data-testid={`footer-link-${s.slug}`} className="group inline-flex items-center gap-1.5 text-sm text-[#F4F4F0]/75 transition-colors hover:text-[#2FBF8F]">
                  {s.name}
                  <ArrowUpRight size={12} className="opacity-0 transition-opacity group-hover:opacity-100" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#8C8C8C]">Le site</p>
          <ul className="mt-5 space-y-3">
            {[
              ["Accueil", "/"],
              ["Réalisations", "/realisations"],
              ["Zone d'intervention", "/zone-intervention"],
              ["Blog", "/blog"],
              ["À propos", "/a-propos"],
              ["Contact", "/contact"],
              ["Devis", "/devis"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-nav-${to.replace(/\//g, "") || "home"}`} className="text-sm text-[#F4F4F0]/75 transition-colors hover:text-[#2FBF8F]">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#8C8C8C]">Légal</p>
          <ul className="mt-5 space-y-3">
            <li><Link to="/mentions-legales" data-testid="footer-legal" className="text-sm text-[#F4F4F0]/75 transition-colors hover:text-[#2FBF8F]">Mentions légales</Link></li>
            <li><Link to="/politique-de-confidentialite" data-testid="footer-privacy" className="text-sm text-[#F4F4F0]/75 transition-colors hover:text-[#2FBF8F]">Politique de confidentialité</Link></li>
            <li><Link to="/cookies" data-testid="footer-cookies" className="text-sm text-[#F4F4F0]/75 transition-colors hover:text-[#2FBF8F]">Cookies</Link></li>
          </ul>
          <Link
            to="/devis"
            data-testid="footer-devis-cta"
            className="group relative mt-8 inline-flex overflow-hidden border border-[#047857] px-5 py-3 text-[11px] font-medium uppercase tracking-[0.2em] text-[#F4F4F0]"
          >
            <span className="absolute inset-0 -translate-x-full bg-[#047857] transition-transform duration-500 ease-out group-hover:translate-x-0" />
            <span className="relative">Demander un devis</span>
          </Link>
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-[#8C8C8C] md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Resineko — Tous droits réservés.</p>
        <p>Basés à Daux (31), région toulousaine — Intervention partout en France.</p>
      </div>
    </div>
  </footer>
);
